import { useEffect } from 'react';
import { useSelector } from 'react-redux'

const ChatwootWidget = () => {
  const userInfo = useSelector(state => state.auth.userInfo);

  useEffect(() => {
    initChatwoot();
  }, [])

  useEffect(() => {
    if (userInfo ) {
      const userChatwoot = userInfo?.chatwoot;
      window.$chatwoot?.setUser(userChatwoot.email, {
        name: userChatwoot.name,
        email: userChatwoot.email,
        identifier_hash: userChatwoot.user_hash
      })
      window.$chatwoot?.setLocale(userChatwoot.language_override)
    }
  }, [userInfo?.chatwoot])

  useEffect(() => {
    if (userInfo?.customer_language) {
      window.$chatwoot?.setLocale(userInfo?.customer_language)
    }
  }, [userInfo?.customer_language])

  const initChatwoot = () => {
    (function(d, t) {
      var BASE_URL = "https://chat.cystack.org";
      var g = d.createElement(t), s = d.getElementsByTagName(t)[0];
      g.src = BASE_URL + "/packs/js/sdk.js";
      g.defer = true;
      g.async = true;
      s.parentNode.insertBefore(g, s);
      g.onload = function() {
        window.chatwootSDK.run({
          websiteToken: process.env.REACT_APP_CHATWOOT_TOKEN,
          baseUrl: BASE_URL,
        });
      };
    })(document, "script");
  
    window.chatwootSettings = {
      baseDomain: '.locker.io'
      // darkMode: 'auto'
    }
  }
};

export default ChatwootWidget;
